module.exports = new __parcel__URL__("report-burnup.d56fdf25.svg").toString();